import React, { FC } from 'react';
import { StyledContainer } from './style';

interface InternalContainerProps {
  align?: 'center' | 'flex-start' | 'flex-end';
  justify?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around';
  direction?: string;
  className?: any;
  width?: string;
  fullHeight?: boolean;
  padding?: string;
}
const InternalContainer: FC<InternalContainerProps> = ({
  align,
  children,
  justify,
  direction,
  className,
  width,
  fullHeight,
  padding,
}) => {
  return (
    <StyledContainer
      align={align}
      className={className}
      direction={direction}
      justify={justify}
      width={width}
      fullHeight={fullHeight}
      padding={padding}
    >
      {children}
    </StyledContainer>
  );
};

export default InternalContainer;
